const state = {
  loading: JSON.parse(sessionStorage.getItem('loading')) || false
}

const mutations = {
  myLoading (state, data) {
    state.loading = data
    sessionStorage.setItem('loading', JSON.stringify(state.loading))
  }
}

const actions = {
  myLoading (context, data) {
    context.commit('myLoading', data)
  }
}

export default{
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/loading.js